import { Component, forwardRef, input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
  selector: 'dbx-banner',
  imports: [MatIcon, MatCard, MatCardContent],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BannerComponent),
      multi: true,
    },
  ],
})
export class BannerComponent {
  fontIcon = input<string>('');
}
